import React from "react"
import {connect} from 'react-redux'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"

import extendedTablesStyle from "./extendedTablesStyle.jsx"

import {primaryColor} from "../../assets/jss/material-dashboard-pro-react";
import {systemService} from "../../_services";
import NavPills from "../../components/NavPills";
import Table from "../../components/Table";
import MyDropdown from "../../components/MyDropdown";
import {getUserType} from "../../_services/authenticate";
import Button from "../../components/CustomButtons";
import CustomInput from "../../components/CustomInput";
import {Alert} from "@mui/material";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {sweetAlertActions} from "../../_actions";
import Loader from "../../components/Loader/Loader.jsx";
import {getInternalUsers, getUsersForOrganisation, getUsersForPartner, getUserByEmail, inviteUser} from "../../_services/user.service.js";

class Authorisation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error_message: "",
      warning_message: "",
      internal_users: [],
      organisation_id: null,
      organisation_users: [],
      loading_organisation_users: false,
      partner_id: null,
      partner_users: [],
      loading_partner_users: false,
      email: null,
      email_error_message: "",
      role: null,
      role_error_message: "",
      name: null,
      name_error_message: "",
      family_name: null,
      family_name_error_message: "",
      locales: [],
      locale: null,
      internal_user: false,
      search_email: "",
      searched_user: null,
      loading_user_details: false,
      user_details_error: null
    }

    this.timer = null
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
    this.refresh()
    this.validate_inputs()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this._is_mounted = false
  }

  invite_user() {
    const {dispatch} = this.props
    const {organisation_id, partner_id, role, email, name, family_name, locale, internal_user} = this.state
    let org_id = organisation_id
    let part_id = partner_id
    dispatch(sweetAlertActions.clean({
      title: "Invite in progress...",
      content: <div>
        <Loader/>
        <br/>
        <p>The servers are processing the request for <b>{email}</b>, this may take a few minutes...</p>
        <p><b>First name:</b> {name}</p>
        <p><b>Family name:</b> {family_name}</p>
        <p><b>Role:</b> {role}</p>
        <p><b>Octiva Employee:</b> {internal_user}</p>
        <p><b>Organization ID:</b> {org_id}</p>
        <p><b>Partner ID:</b> {part_id}</p>
      </div>
    }))
    inviteUser(org_id, part_id, name, family_name, locale, email, role, internal_user,
      res => {
        this.setState({
          role: null,
          email: "",
          name: "",
          family_name: "",
          locale: null,
          organisation_id: null,
          partner_id: null
        }, this.validate_inputs.bind(this))

        console.debug('RES: ' + res)

        dispatch(sweetAlertActions.success({
          title: "User Invited",
          content: <div>
            <p>This user has been invited and will receive an email with the invitation to join.</p>
          </div>
        }))
    }, error => {
        console.debug("Error inviting user:", error);
        dispatch(sweetAlertActions.danger({
          title: "User is not invited",
          content: <div>
            <p>Ask your Nimbus administrator for help!</p>
            <p><b>Error:</b> {error}</p>
          </div>
        }))
    })
  }

  validateEmail(email) {
    return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }

  validate_inputs() {
    const {organisation_id, partner_id, role, email, name, family_name, locale, internal_user} = this.state
    let error_message = ""
    let warning_message = ""

    if (!email || !this.validateEmail(email)) {
      this.setState({email_error_message: "Email address is not valid."})
      error_message = "Invalid inputs..."
    } else {
      this.setState({email_error_message: ""})
    }

    if (!name) {
      this.setState({name_error_message: "First name cannot be empty."})
      error_message = "Invalid inputs..."
    } else {
      this.setState({name_error_message: ""})
    }

    if (!family_name){
      this.setState({family_name_error_message: "Family name cannot be empty."})
      error_message = "Invalid inputs..."
    } else {
      this.setState({family_name_error_message: ""})
    }

    if (!role){
      this.setState({role_error_message: "Role cannot be empty."})
    }
    if (!locale){
      error_message = "Locale must be selected."
    }
    if ((partner_id || internal_user) && getUserType() !== "system_admin") {
      error_message = "Only Octiva admins can invite Octiva and partner users."
    } else {
      // Add here that either internal_user, or partner_id, or organisation_id needs to be selected.
      // And only one of them.
        if (!internal_user && !partner_id && !organisation_id) {
          error_message = "Either internal user, partner, or organisation must be selected."
        }
        if ((internal_user && partner_id) || (internal_user && organisation_id) || (partner_id && organisation_id)) {
          error_message = "Only one of internal user, partner, or organisation can be selected."
        }

    }
    this.setState({
      error_message, warning_message
    })
  }

  refresh() {
    const {organisation_id, partner_id} = this.state
    systemService.getLocales(res => {
      this.setState({locales: res.locales})
    })
    getInternalUsers(res => {
      this.setState({internal_users: res.users})
    })
    if (organisation_id !== null) {
      this.setState({loading_organisation_users: true})
      getUsersForOrganisation(organisation_id, res => {
        this.setState({organisation_users: res.users, loading_organisation_users: false})
      }
      ,error => {
          this.setState({loading_organisation_users: false})
          console.error("Error fetching organisation users: ", error)
      })
    }
    if (partner_id !== null) {
      this.setState({loading_partner_users: true})
      getUsersForPartner(partner_id, res => {
        this.setState({partner_users: res.users, loading_partner_users: false})
      }
      ,error => {
        this.setState({loading_partner_users: false})
        console.error("Error fetching partner users: ", error)
      })
    }
  }

  validate_and_refresh() {
    this.validate_inputs()
    this.refresh()
  }

  handle_form_input_selector(name, value) {
    this.setState({[name]: value}, this.validate_and_refresh.bind(this))
  }

  search_user_by_email() {
    const {search_email} = this.state
    
    if (!search_email || !this.validateEmail(search_email)) {
      this.setState({user_details_error: "Please enter a valid email address"})
      return
    }

    this.setState({loading_user_details: true, user_details_error: null, searched_user: null})
    
    getUserByEmail(search_email,
      user => {
        this.setState({
          searched_user: user,
          loading_user_details: false
        })
      },
      error => {
        this.setState({
          loading_user_details: false,
          user_details_error: typeof error === 'string' ? error : (error.message || "User not found")
        })
      }
    )
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.organisations !== this.props.organisations || prevProps.partners !== this.props.partners || prevProps.locations !== this.props.locations || prevProps.all_devices !== this.props.all_devices || prevProps.deployments !== this.props.deployments) {
      this.refresh()
    }
  }

  render() {
    const {organisations, partners} = this.props
    console.error("DEBUG: partners: ", partners)
    const {
      error_message,
      warning_message,
      internal_users,
      organisation_id,
      organisation_users,
      loading_organisation_users,
      partner_id,
      partner_users,
      loading_partner_users,
      name,
      name_error_message,
      family_name,
      family_name_error_message,
      email,
      email_error_message,
      role,
      locales,
      locale,
      internal_user,
      search_email,
      searched_user,
      loading_user_details,
      user_details_error
    } = this.state

    let tabs = [
      {
        tabButton: "Octiva Employees",
        tabContent: <Card>
          <CardHeader>
            <GridContainer>
              <GridItem xs={10}>
                <h4 style={{color: primaryColor}}>
                  <b>{"Octiva Employees"}</b></h4>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <Table
                    tableData={[
                      [<b>First Name</b>,  <b>Family Name</b>,  <b>Locale</b>,  <b>Email</b>, <b>Role</b>],
                      ...internal_users.map(user => {
                        return [
                          user['first_name'],
                          user['last_name'],
                          locales.map((locale) => locale["id"]).includes(user['locale']) ? <span>{
                            locales.find(x => x.id === user['locale']) ? locales.find(x => x.id === user['locale']).name : user['locale']
                          }</span> : <span  style={{color: "rgb(231,92,92)"}}>{user["locale"] ? user['locale'] : "-"}</span> ,
                          user['email'],
                          user['role'],
                          
                        ]
                      }),
                      ["", "", "", "", ""]
                    ]}
                  />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      },
      {
        tabButton: "Organisation Users",
        tabContent: <Card>
          <CardHeader>
            <GridContainer>
              <GridItem xs={10}>
                <h4 style={{color: primaryColor}}>
                  <b>{"Organisation Users"}</b></h4>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <MyDropdown
                  input_label={"Organisation"}
                  name={"organisation_id"}
                  value={organisation_id}
                  default_value={organisation_id}
                  options={[...Object.keys(organisations).sort((a, b) => {
                    return organisations[a]["name"] < organisations[b]["name"] ? -1 : 1
                  }).map((org_id) => {
                    return {id: org_id, value: organisations[org_id].name}
                  })]}
                  handle_selection={this.handle_form_input_selector.bind(this)}
                />
              </GridItem>
              <GridItem xs={12}>
                {loading_organisation_users ?
                  <Loader/> :
                  <Table
                    tableData={[
                      [<b>First Name</b>,  <b>Family Name</b>,  <b>Locale</b>,  <b>Email</b>, <b>Role</b>],
                      ...organisation_users.map(user => {
                        return [
                          user['first_name'],
                          user['last_name'],
                          locales.map((locale) => locale["id"]).includes(user['locale']) ? <span>{
                            locales.find(x => x.id === user['locale']) ? locales.find(x => x.id === user['locale']).name : user['locale']
                          }</span> : <span  style={{color: "rgb(231,92,92)"}}>{user["locale"] ? user['locale'] : "-"}</span> ,
                          user['email'],
                          user['role'],
                          
                        ]
                      }),
                      ["", "", "", "", ""]
                    ]}
                  />
                }
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      },
      {
        tabButton: "Partner Users",
        tabContent: <Card>
          <CardHeader>
            <GridContainer>
              <GridItem xs={10}>
                <h4 style={{color: primaryColor}}>
                  <b>{"Partner Users"}</b></h4>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <MyDropdown
                  input_label={"Partner"}
                  name={"partner_id"}
                  value={partner_id}
                  default_value={partner_id}
                  options={[...Object.keys(partners).sort((a, b) => {
                    return partners[a]["name"] < partners[b]["name"] ? -1 : 1
                  }).map((org_id) => {
                    return {id: org_id, value: partners[org_id].name}
                  })]}
                  handle_selection={this.handle_form_input_selector.bind(this)}
                />
              </GridItem>
              <GridItem xs={12}>
                {loading_partner_users ?
                  <Loader/> :
                  <Table
                    tableData={[
                      [<b>First Name</b>,  <b>Family Name</b>,  <b>Locale</b>,  <b>Email</b>, <b>Role</b>],
                      ...partner_users.map(user => {
                        return [
                          user['first_name'],
                          user['last_name'],
                          locales.map((locale) => locale["id"]).includes(user['locale']) ? <span>{
                            locales.find(x => x.id === user['locale']) ? locales.find(x => x.id === user['locale']).name : user['locale']
                          }</span> : <span  style={{color: "rgb(231,92,92)"}}>{user["locale"] ? user['locale'] : "-"}</span> ,
                          user['email'],
                          user['role'],
                          
                        ]
                      }),
                      ["", "", "", "", ""]
                    ]}
                  />
                }
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      },
      {
        tabButton: "User Details",
        tabContent: <Card>
          <CardHeader>
            <GridContainer>
              <GridItem xs={10}>
                <h4 style={{color: primaryColor}}>
                  <b>{"User Details"}</b></h4>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  labelText={"Search User by Email"}
                  inputProps={{
                    onChange: event => this.setState({search_email: event.target.value.toLowerCase()}),
                    type: "email",
                    value: search_email,
                    onKeyUp: event => {
                      if (event.key === "Enter") {
                        this.search_user_by_email()
                      }
                    }
                  }}
                />
                <Button
                  simple
                  color={"primary"}
                  onClick={this.search_user_by_email.bind(this)}
                >
                  Search User
                </Button>
              </GridItem>

              {user_details_error && (
                <GridItem xs={12}>
                  <Alert severity={"error"}>{user_details_error}</Alert>
                </GridItem>
              )}

              <GridItem xs={12}>
                {loading_user_details ? (
                  <Loader/>
                ) : searched_user ? (
                  <Table
                    tableData={[
                      [<b>Field</b>, <b>Value</b>],
                      ["ID", searched_user.id || "-"],
                      ["First Name", searched_user.first_name || "-"],
                      ["Last Name", searched_user.last_name || "-"],
                      ["Email", searched_user.email || "-"],
                      ["Language", 
                        locales.map((locale) => locale["id"]).includes(searched_user.locale) ? (
                          <span>{
                            locales.find(x => x.id === searched_user.locale) ? 
                              locales.find(x => x.id === searched_user.locale).name : 
                              searched_user.locale
                          }</span>
                        ) : (
                          <span style={{color: "rgb(231,92,92)"}}>{searched_user.locale || "-"}</span>
                        )
                      ],
                      ["Role", searched_user.role || "-"],
                      ["Organisation ID", searched_user.organisation_id || "-"],
                      ["Partner ID", searched_user.partner_id || "-"],
                      ["Internal User", searched_user.internal_user !== null && searched_user.internal_user !== undefined ? 
                        (searched_user.internal_user ? "Yes" : "No") : "-"
                      ],
                      ["MFA Enabled", searched_user.cognito_details && searched_user.cognito_details.mfa_enabled !== undefined ?
                        (searched_user.cognito_details.mfa_enabled ? "Yes" : "No") : "-"
                      ],
                      ["Status", searched_user.cognito_details && searched_user.cognito_details.status ?
                        searched_user.cognito_details.status : "-"
                      ],
                      ["", ""]
                    ]}
                  />
                ) : null}
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      },
      {
        tabButton: "Manage Users",
        tabContent: <Card>
          <CardHeader>
            <GridContainer>
              <GridItem xs={10}>
                <h4 style={{color: primaryColor}}>
                  <b>{"Manage Users"}</b></h4>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  labelText={"First Name"}
                  error={name_error_message !== ""}
                  helpText={name_error_message}
                  inputProps={{
                    onChange: event => this.handle_form_input_selector("name", event.target.value),
                    type: "text",
                    value: name
                  }}
                />
                <CustomInput
                  labelText={"Family Name"}
                  error={family_name_error_message !== ""}
                  helpText={family_name_error_message}
                  inputProps={{
                    onChange: event => this.handle_form_input_selector("family_name", event.target.value),
                    type: "text",
                    value: family_name
                  }}
                />
                <CustomInput
                  labelText={"Email Address"}
                  error={email_error_message !== ""}
                  helpText={email_error_message}
                  inputProps={{
                    onChange: event => this.handle_form_input_selector("email", event.target.value.toLowerCase()),
                    type: "email",
                    value: email
                  }}
                />
                <MyDropdown
                  input_label={"Locale"}
                  name={"locale"}
                  value={locale}
                  default_value={locale}
                  options={locales.sort((a, b) => {
                    return [a]["name"] < [b]["name"] ? -1 : 1
                  }).map((loc) => {
                    return {id: loc.id, value: loc.name}
                  })}
                  handle_selection={this.handle_form_input_selector.bind(this)}
                />
                <MyDropdown
                  input_label={"Role"}
                  name={"role"}
                  value={role}
                  default_value={role}
                  options={[
                    {id: "admin", value: "Admin"},
                    {id: "license_support_engineer", value: "License Support Engineer"},
                    {id: "user", value: "User"},
                  ]}
                  handle_selection={this.handle_form_input_selector.bind(this)}
                />
                <MyDropdown
                  input_label={"Organisation"}
                  name={"organisation_id"}
                  value={organisation_id}
                  default_value={organisation_id}
                  options={[{id: null, value: "No organisation"}, ...Object.keys(organisations).sort((a, b) => {
                    return organisations[a]["name"] < organisations[b]["name"] ? -1 : 1
                  }).map((org_id) => {
                    return {id: org_id, value: organisations[org_id].name}
                  })]}
                  handle_selection={this.handle_form_input_selector.bind(this)}
                />
                <MyDropdown
                  input_label={"Partner"}
                  name={"partner_id"}
                  value={partner_id}
                  default_value={partner_id}
                  options={[{id: null, value: "No partner"}, ...Object.keys(partners).sort((a, b) => {
                    return partners[a]["name"] < partners[b]["name"] ? -1 : 1
                  }).map((org_id) => {
                    return {id: org_id, value: partners[org_id].name}
                  })]}
                  handle_selection={this.handle_form_input_selector.bind(this)}
                />
                <FormControlLabel
                  label={<span style={{ color: "#3c4858" }}>Octiva Employee</span>}
                  labelPlacement="start"
                  control={
                    <Checkbox
                      checked={internal_user}
                      onChange={event => this.handle_form_input_selector("internal_user", event.target.checked)}
                      color="primary"
                    />
                  }
                />
                

                {error_message !== "" &&
                  <Alert severity={"error"}> {error_message}</Alert>
                }

                {warning_message !== "" &&
                  <Alert severity={"warning"}> {warning_message}</Alert>
                }

                <Button
                  simple
                  color={"primary"}
                  disabled={name_error_message !== "" || family_name_error_message !== "" || email_error_message !== "" || error_message !== "" || !role}
                  onClick={this.invite_user.bind(this)}
                >
                  Invite User
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      }
    ]
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <NavPills
            tabs={tabs}
          />
        </GridItem>
      </GridContainer>
    )
  }
}


function mapStateToProps(state) {
  const {organisations, partners, locations, deployments} = state.location
  const {all_devices} = state.device_fleet
  console.error("DEBUG: mapStateToProps - organisations: ", organisations)
  console.error("DEBUG: mapStateToProps - partners: ", partners)
  
  return {
    organisations, partners, locations, all_devices, deployments
  }
}


export default withStyles(extendedTablesStyle)(connect(mapStateToProps)(Authorisation))
